{
  "version": 1,
  "asset_id": "1aa8a00b-0e3a-4f3e-ab34-19be57d243e3",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/1aa8a00b-0e3a-4f3e-ab34-19be57d243e3/interior-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/1aa8a00b-0e3a-4f3e-ab34-19be57d243e3/interior-hero.webp",
  "original_filename": "interior-hero.webp",
  "size": 166116,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:50Z"
}
